<template>
  <img alt="Vue logo" src="./assets/logo.png">
  <div>
    <h1>Are You OK?</h1>
    <input type="text" v-model="name" id="input">
    <button @click="handleClick" id="button">你好</button>
  </div>
</template>

<script>
export default {
  name: 'App',
  data() {
    return {
      name: 'World'
    }
  },
  methods: {
    handleClick() {
      alert(this.name)
    }
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
button {
  background-color: #fff;
  border: 1px solid #ccc;
  border-radius: 3px;
  padding: 0.5em 1em;
  margin: 0.5em;
  font-size: 1em;
  cursor: pointer;
}
#input {
  border: 1px solid #ccc;
  border-radius: 3px;
  padding: 0.5em 1em;
  margin: 0.5em;
  font-size: 1em;
}
</style>
